<cm-indicator
    *ngIf="step.paid_by_info"
    class="indicator indicator--employer"
    placement="left"
    container="body"
    [ngbTooltip]="paidInfo"
    >E</cm-indicator
>
<cm-on-behalf-indicator
    *ngIf="step.on_behalf_indicator"
    class="indicator"
    [onBehalfIndicator]="step.on_behalf_indicator"
></cm-on-behalf-indicator>
